import React from "react";
import LeadForm from "../components/LeadForm";
import { brand, offices } from "../mock";
import { Mail, Phone, MessageCircle, MapPin } from "lucide-react";

export default function ContactPage() {
  return (
    <>
      <section className="bg-gradient-to-b from-slate-50 to-white py-16 md:py-20 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Contact</div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0B2447] tracking-tight">Get a free, no-obligation assessment</h1>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">Tell us what's hurting you and a real specialist will get back within one business day. If we can't remove it, you don't pay.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="space-y-6">
            <ContactCard icon={Mail} title="Email us" value={brand.email} href={`mailto:${brand.email}`} />
            {brand.phones.map((p, i) => (
              <ContactCard key={p} icon={Phone} title={i === 0 ? "Call Singapore" : "Call India"} value={p} href={`tel:${p.replace(/\s/g, "")}`} />
            ))}
            <ContactCard icon={MessageCircle} title="WhatsApp" value="Chat with a specialist" href={brand.whatsapp} />
            <div className="rounded-2xl border border-slate-200 bg-white p-6">
              <div className="w-10 h-10 rounded-lg bg-[#0B2447]/5 flex items-center justify-center mb-3">
                <MapPin className="w-5 h-5 text-[#0B2447]" />
              </div>
              <div className="font-semibold text-[#0B2447] mb-3">Global offices</div>
              <ul className="space-y-2 text-sm text-slate-600">
                {offices.map((o) => (
                  <li key={o.country}><span className="font-medium text-[#0B2447]">{o.country}:</span> {o.address}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="lg:col-span-2">
            <LeadForm />
          </div>
        </div>
      </section>
    </>
  );
}

function ContactCard({ icon: Icon, title, value, href }) {
  return (
    <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="block rounded-2xl border border-slate-200 bg-white p-6 hover:border-[#0B2447] hover:shadow-md transition-all">
      <div className="w-10 h-10 rounded-lg bg-[#0B2447]/5 flex items-center justify-center mb-3">
        <Icon className="w-5 h-5 text-[#0B2447]" />
      </div>
      <div className="text-xs uppercase tracking-widest text-slate-500">{title}</div>
      <div className="mt-1 font-semibold text-[#0B2447] break-all">{value}</div>
    </a>
  );
}
